/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as InvitoRouteImport } from './routes/invito'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppImpostazioniRouteImport } from './routes/_app/impostazioni'
import { Route as AppAffollamentoIndexRouteImport } from './routes/_app/affollamento.index'
import { Route as AppAgendaIndexRouteImport } from './routes/_app/agenda.index'
import { Route as AppAnalisiIndexRouteImport } from './routes/_app/analisi.index'
import { Route as AppAutomazioniIndexRouteImport } from './routes/_app/automazioni.index'
import { Route as AppContattiIndexRouteImport } from './routes/_app/contatti.index'
import { Route as AppContattiImportRouteImport } from './routes/_app/contatti.import'
import { Route as AppDocumentiIndexRouteImport } from './routes/_app/documenti.index'
import { Route as AppEserciziIndexRouteImport } from './routes/_app/esercizi.index'
import { Route as AppEserciziBulkRouteImport } from './routes/_app/esercizi.bulk'
import { Route as AppImportIndexRouteImport } from './routes/_app/import.index'
import { Route as AppImportJobIdRouteImport } from './routes/_app/import.$jobId'
import { Route as AppIscrittiIndexRouteImport } from './routes/_app/iscritti.index'
import { Route as AppIscrittiGymMemberIdRouteImport } from './routes/_app/iscritti.$gymMemberId'
import { Route as AppIscrittiImportRouteImport } from './routes/_app/iscritti.import'
import { Route as AppListiniIndexRouteImport } from './routes/_app/listini.index'
import { Route as AppMagazzinoIndexRouteImport } from './routes/_app/magazzino.index'
import { Route as AppOperatoriIndexRouteImport } from './routes/_app/operatori.index'
import { Route as AppOrdiniIndexRouteImport } from './routes/_app/ordini.index'
import { Route as AppOrganizzazioneIndexRouteImport } from './routes/_app/organizzazione.index'
import { Route as AppPalinsestoIndexRouteImport } from './routes/_app/palinsesto.index'
import { Route as AppPianiAlimentariIndexRouteImport } from './routes/_app/piani-alimentari.index'
import { Route as AppReceptionIndexRouteImport } from './routes/_app/reception.index'
import { Route as AppRegistroIndexRouteImport } from './routes/_app/registro.index'
import { Route as AppScadenzarioIndexRouteImport } from './routes/_app/scadenzario.index'
import { Route as AppSchedeIndexRouteImport } from './routes/_app/schede.index'
import { Route as AppSegmentiIndexRouteImport } from './routes/_app/segmenti.index'
import { Route as AppServiziIndexRouteImport } from './routes/_app/servizi.index'
import { Route as AppUtentiIndexRouteImport } from './routes/_app/utenti.index'
import { Route as AppUtentiUserIdRouteImport } from './routes/_app/utenti.$userId'
import { Route as AppVenditeIndexRouteImport } from './routes/_app/vendite.index'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitoRoute = InvitoRouteImport.update({
  id: '/invito',
  path: '/invito',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppImpostazioniRoute = AppImpostazioniRouteImport.update({
  id: '/impostazioni',
  path: '/impostazioni',
  getParentRoute: () => AppRoute,
} as any)
const AppAffollamentoIndexRoute = AppAffollamentoIndexRouteImport.update({
  id: '/affollamento/',
  path: '/affollamento/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendaIndexRoute = AppAgendaIndexRouteImport.update({
  id: '/agenda/',
  path: '/agenda/',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalisiIndexRoute = AppAnalisiIndexRouteImport.update({
  id: '/analisi/',
  path: '/analisi/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomazioniIndexRoute = AppAutomazioniIndexRouteImport.update({
  id: '/automazioni/',
  path: '/automazioni/',
  getParentRoute: () => AppRoute,
} as any)
const AppContattiIndexRoute = AppContattiIndexRouteImport.update({
  id: '/contatti/',
  path: '/contatti/',
  getParentRoute: () => AppRoute,
} as any)
const AppContattiImportRoute = AppContattiImportRouteImport.update({
  id: '/contatti/import',
  path: '/contatti/import',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentiIndexRoute = AppDocumentiIndexRouteImport.update({
  id: '/documenti/',
  path: '/documenti/',
  getParentRoute: () => AppRoute,
} as any)
const AppEserciziIndexRoute = AppEserciziIndexRouteImport.update({
  id: '/esercizi/',
  path: '/esercizi/',
  getParentRoute: () => AppRoute,
} as any)
const AppEserciziBulkRoute = AppEserciziBulkRouteImport.update({
  id: '/esercizi/bulk',
  path: '/esercizi/bulk',
  getParentRoute: () => AppRoute,
} as any)
const AppImportIndexRoute = AppImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => AppRoute,
} as any)
const AppImportJobIdRoute = AppImportJobIdRouteImport.update({
  id: '/import/$jobId',
  path: '/import/$jobId',
  getParentRoute: () => AppRoute,
} as any)
const AppIscrittiIndexRoute = AppIscrittiIndexRouteImport.update({
  id: '/iscritti/',
  path: '/iscritti/',
  getParentRoute: () => AppRoute,
} as any)
const AppIscrittiGymMemberIdRoute = AppIscrittiGymMemberIdRouteImport.update({
  id: '/iscritti/$gymMemberId',
  path: '/iscritti/$gymMemberId',
  getParentRoute: () => AppRoute,
} as any)
const AppIscrittiImportRoute = AppIscrittiImportRouteImport.update({
  id: '/iscritti/import',
  path: '/iscritti/import',
  getParentRoute: () => AppRoute,
} as any)
const AppListiniIndexRoute = AppListiniIndexRouteImport.update({
  id: '/listini/',
  path: '/listini/',
  getParentRoute: () => AppRoute,
} as any)
const AppMagazzinoIndexRoute = AppMagazzinoIndexRouteImport.update({
  id: '/magazzino/',
  path: '/magazzino/',
  getParentRoute: () => AppRoute,
} as any)
const AppOperatoriIndexRoute = AppOperatoriIndexRouteImport.update({
  id: '/operatori/',
  path: '/operatori/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdiniIndexRoute = AppOrdiniIndexRouteImport.update({
  id: '/ordini/',
  path: '/ordini/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizzazioneIndexRoute = AppOrganizzazioneIndexRouteImport.update({
  id: '/organizzazione/',
  path: '/organizzazione/',
  getParentRoute: () => AppRoute,
} as any)
const AppPalinsestoIndexRoute = AppPalinsestoIndexRouteImport.update({
  id: '/palinsesto/',
  path: '/palinsesto/',
  getParentRoute: () => AppRoute,
} as any)
const AppPianiAlimentariIndexRoute = AppPianiAlimentariIndexRouteImport.update({
  id: '/piani-alimentari/',
  path: '/piani-alimentari/',
  getParentRoute: () => AppRoute,
} as any)
const AppReceptionIndexRoute = AppReceptionIndexRouteImport.update({
  id: '/reception/',
  path: '/reception/',
  getParentRoute: () => AppRoute,
} as any)
const AppRegistroIndexRoute = AppRegistroIndexRouteImport.update({
  id: '/registro/',
  path: '/registro/',
  getParentRoute: () => AppRoute,
} as any)
const AppScadenzarioIndexRoute = AppScadenzarioIndexRouteImport.update({
  id: '/scadenzario/',
  path: '/scadenzario/',
  getParentRoute: () => AppRoute,
} as any)
const AppSchedeIndexRoute = AppSchedeIndexRouteImport.update({
  id: '/schede/',
  path: '/schede/',
  getParentRoute: () => AppRoute,
} as any)
const AppSegmentiIndexRoute = AppSegmentiIndexRouteImport.update({
  id: '/segmenti/',
  path: '/segmenti/',
  getParentRoute: () => AppRoute,
} as any)
const AppServiziIndexRoute = AppServiziIndexRouteImport.update({
  id: '/servizi/',
  path: '/servizi/',
  getParentRoute: () => AppRoute,
} as any)
const AppUtentiIndexRoute = AppUtentiIndexRouteImport.update({
  id: '/utenti/',
  path: '/utenti/',
  getParentRoute: () => AppRoute,
} as any)
const AppUtentiUserIdRoute = AppUtentiUserIdRouteImport.update({
  id: '/utenti/$userId',
  path: '/utenti/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppVenditeIndexRoute = AppVenditeIndexRouteImport.update({
  id: '/vendite/',
  path: '/vendite/',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/invito': typeof InvitoRoute
  '/login': typeof LoginRoute
  '/impostazioni': typeof AppImpostazioniRoute
  '/contatti/import': typeof AppContattiImportRoute
  '/esercizi/bulk': typeof AppEserciziBulkRoute
  '/import/$jobId': typeof AppImportJobIdRoute
  '/iscritti/$gymMemberId': typeof AppIscrittiGymMemberIdRoute
  '/iscritti/import': typeof AppIscrittiImportRoute
  '/utenti/$userId': typeof AppUtentiUserIdRoute
  '/affollamento/': typeof AppAffollamentoIndexRoute
  '/agenda/': typeof AppAgendaIndexRoute
  '/analisi/': typeof AppAnalisiIndexRoute
  '/automazioni/': typeof AppAutomazioniIndexRoute
  '/contatti/': typeof AppContattiIndexRoute
  '/documenti/': typeof AppDocumentiIndexRoute
  '/esercizi/': typeof AppEserciziIndexRoute
  '/import/': typeof AppImportIndexRoute
  '/iscritti/': typeof AppIscrittiIndexRoute
  '/listini/': typeof AppListiniIndexRoute
  '/magazzino/': typeof AppMagazzinoIndexRoute
  '/operatori/': typeof AppOperatoriIndexRoute
  '/ordini/': typeof AppOrdiniIndexRoute
  '/organizzazione/': typeof AppOrganizzazioneIndexRoute
  '/palinsesto/': typeof AppPalinsestoIndexRoute
  '/piani-alimentari/': typeof AppPianiAlimentariIndexRoute
  '/reception/': typeof AppReceptionIndexRoute
  '/registro/': typeof AppRegistroIndexRoute
  '/scadenzario/': typeof AppScadenzarioIndexRoute
  '/schede/': typeof AppSchedeIndexRoute
  '/segmenti/': typeof AppSegmentiIndexRoute
  '/servizi/': typeof AppServiziIndexRoute
  '/utenti/': typeof AppUtentiIndexRoute
  '/vendite/': typeof AppVenditeIndexRoute
}
export interface FileRoutesByTo {
  '/invito': typeof InvitoRoute
  '/login': typeof LoginRoute
  '/impostazioni': typeof AppImpostazioniRoute
  '/': typeof AppIndexRoute
  '/contatti/import': typeof AppContattiImportRoute
  '/esercizi/bulk': typeof AppEserciziBulkRoute
  '/import/$jobId': typeof AppImportJobIdRoute
  '/iscritti/$gymMemberId': typeof AppIscrittiGymMemberIdRoute
  '/iscritti/import': typeof AppIscrittiImportRoute
  '/utenti/$userId': typeof AppUtentiUserIdRoute
  '/affollamento': typeof AppAffollamentoIndexRoute
  '/agenda': typeof AppAgendaIndexRoute
  '/analisi': typeof AppAnalisiIndexRoute
  '/automazioni': typeof AppAutomazioniIndexRoute
  '/contatti': typeof AppContattiIndexRoute
  '/documenti': typeof AppDocumentiIndexRoute
  '/esercizi': typeof AppEserciziIndexRoute
  '/import': typeof AppImportIndexRoute
  '/iscritti': typeof AppIscrittiIndexRoute
  '/listini': typeof AppListiniIndexRoute
  '/magazzino': typeof AppMagazzinoIndexRoute
  '/operatori': typeof AppOperatoriIndexRoute
  '/ordini': typeof AppOrdiniIndexRoute
  '/organizzazione': typeof AppOrganizzazioneIndexRoute
  '/palinsesto': typeof AppPalinsestoIndexRoute
  '/piani-alimentari': typeof AppPianiAlimentariIndexRoute
  '/reception': typeof AppReceptionIndexRoute
  '/registro': typeof AppRegistroIndexRoute
  '/scadenzario': typeof AppScadenzarioIndexRoute
  '/schede': typeof AppSchedeIndexRoute
  '/segmenti': typeof AppSegmentiIndexRoute
  '/servizi': typeof AppServiziIndexRoute
  '/utenti': typeof AppUtentiIndexRoute
  '/vendite': typeof AppVenditeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/invito': typeof InvitoRoute
  '/login': typeof LoginRoute
  '/_app/impostazioni': typeof AppImpostazioniRoute
  '/_app/': typeof AppIndexRoute
  '/_app/contatti/import': typeof AppContattiImportRoute
  '/_app/esercizi/bulk': typeof AppEserciziBulkRoute
  '/_app/import/$jobId': typeof AppImportJobIdRoute
  '/_app/iscritti/$gymMemberId': typeof AppIscrittiGymMemberIdRoute
  '/_app/iscritti/import': typeof AppIscrittiImportRoute
  '/_app/utenti/$userId': typeof AppUtentiUserIdRoute
  '/_app/affollamento/': typeof AppAffollamentoIndexRoute
  '/_app/agenda/': typeof AppAgendaIndexRoute
  '/_app/analisi/': typeof AppAnalisiIndexRoute
  '/_app/automazioni/': typeof AppAutomazioniIndexRoute
  '/_app/contatti/': typeof AppContattiIndexRoute
  '/_app/documenti/': typeof AppDocumentiIndexRoute
  '/_app/esercizi/': typeof AppEserciziIndexRoute
  '/_app/import/': typeof AppImportIndexRoute
  '/_app/iscritti/': typeof AppIscrittiIndexRoute
  '/_app/listini/': typeof AppListiniIndexRoute
  '/_app/magazzino/': typeof AppMagazzinoIndexRoute
  '/_app/operatori/': typeof AppOperatoriIndexRoute
  '/_app/ordini/': typeof AppOrdiniIndexRoute
  '/_app/organizzazione/': typeof AppOrganizzazioneIndexRoute
  '/_app/palinsesto/': typeof AppPalinsestoIndexRoute
  '/_app/piani-alimentari/': typeof AppPianiAlimentariIndexRoute
  '/_app/reception/': typeof AppReceptionIndexRoute
  '/_app/registro/': typeof AppRegistroIndexRoute
  '/_app/scadenzario/': typeof AppScadenzarioIndexRoute
  '/_app/schede/': typeof AppSchedeIndexRoute
  '/_app/segmenti/': typeof AppSegmentiIndexRoute
  '/_app/servizi/': typeof AppServiziIndexRoute
  '/_app/utenti/': typeof AppUtentiIndexRoute
  '/_app/vendite/': typeof AppVenditeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invito'
    | '/login'
    | '/impostazioni'
    | '/contatti/import'
    | '/esercizi/bulk'
    | '/import/$jobId'
    | '/iscritti/$gymMemberId'
    | '/iscritti/import'
    | '/utenti/$userId'
    | '/affollamento/'
    | '/agenda/'
    | '/analisi/'
    | '/automazioni/'
    | '/contatti/'
    | '/documenti/'
    | '/esercizi/'
    | '/import/'
    | '/iscritti/'
    | '/listini/'
    | '/magazzino/'
    | '/operatori/'
    | '/ordini/'
    | '/organizzazione/'
    | '/palinsesto/'
    | '/piani-alimentari/'
    | '/reception/'
    | '/registro/'
    | '/scadenzario/'
    | '/schede/'
    | '/segmenti/'
    | '/servizi/'
    | '/utenti/'
    | '/vendite/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/invito'
    | '/login'
    | '/impostazioni'
    | '/'
    | '/contatti/import'
    | '/esercizi/bulk'
    | '/import/$jobId'
    | '/iscritti/$gymMemberId'
    | '/iscritti/import'
    | '/utenti/$userId'
    | '/affollamento'
    | '/agenda'
    | '/analisi'
    | '/automazioni'
    | '/contatti'
    | '/documenti'
    | '/esercizi'
    | '/import'
    | '/iscritti'
    | '/listini'
    | '/magazzino'
    | '/operatori'
    | '/ordini'
    | '/organizzazione'
    | '/palinsesto'
    | '/piani-alimentari'
    | '/reception'
    | '/registro'
    | '/scadenzario'
    | '/schede'
    | '/segmenti'
    | '/servizi'
    | '/utenti'
    | '/vendite'
  id:
    | '__root__'
    | '/_app'
    | '/invito'
    | '/login'
    | '/_app/impostazioni'
    | '/_app/'
    | '/_app/contatti/import'
    | '/_app/esercizi/bulk'
    | '/_app/import/$jobId'
    | '/_app/iscritti/$gymMemberId'
    | '/_app/iscritti/import'
    | '/_app/utenti/$userId'
    | '/_app/affollamento/'
    | '/_app/agenda/'
    | '/_app/analisi/'
    | '/_app/automazioni/'
    | '/_app/contatti/'
    | '/_app/documenti/'
    | '/_app/esercizi/'
    | '/_app/import/'
    | '/_app/iscritti/'
    | '/_app/listini/'
    | '/_app/magazzino/'
    | '/_app/operatori/'
    | '/_app/ordini/'
    | '/_app/organizzazione/'
    | '/_app/palinsesto/'
    | '/_app/piani-alimentari/'
    | '/_app/reception/'
    | '/_app/registro/'
    | '/_app/scadenzario/'
    | '/_app/schede/'
    | '/_app/segmenti/'
    | '/_app/servizi/'
    | '/_app/utenti/'
    | '/_app/vendite/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  InvitoRoute: typeof InvitoRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invito': {
      id: '/invito'
      path: '/invito'
      fullPath: '/invito'
      preLoaderRoute: typeof InvitoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/impostazioni': {
      id: '/_app/impostazioni'
      path: '/impostazioni'
      fullPath: '/impostazioni'
      preLoaderRoute: typeof AppImpostazioniRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/affollamento/': {
      id: '/_app/affollamento/'
      path: '/affollamento'
      fullPath: '/affollamento/'
      preLoaderRoute: typeof AppAffollamentoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agenda/': {
      id: '/_app/agenda/'
      path: '/agenda'
      fullPath: '/agenda/'
      preLoaderRoute: typeof AppAgendaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analisi/': {
      id: '/_app/analisi/'
      path: '/analisi'
      fullPath: '/analisi/'
      preLoaderRoute: typeof AppAnalisiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automazioni/': {
      id: '/_app/automazioni/'
      path: '/automazioni'
      fullPath: '/automazioni/'
      preLoaderRoute: typeof AppAutomazioniIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contatti/': {
      id: '/_app/contatti/'
      path: '/contatti'
      fullPath: '/contatti/'
      preLoaderRoute: typeof AppContattiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contatti/import': {
      id: '/_app/contatti/import'
      path: '/contatti/import'
      fullPath: '/contatti/import'
      preLoaderRoute: typeof AppContattiImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documenti/': {
      id: '/_app/documenti/'
      path: '/documenti'
      fullPath: '/documenti/'
      preLoaderRoute: typeof AppDocumentiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/esercizi/': {
      id: '/_app/esercizi/'
      path: '/esercizi'
      fullPath: '/esercizi/'
      preLoaderRoute: typeof AppEserciziIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/esercizi/bulk': {
      id: '/_app/esercizi/bulk'
      path: '/esercizi/bulk'
      fullPath: '/esercizi/bulk'
      preLoaderRoute: typeof AppEserciziBulkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import/': {
      id: '/_app/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof AppImportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import/$jobId': {
      id: '/_app/import/$jobId'
      path: '/import/$jobId'
      fullPath: '/import/$jobId'
      preLoaderRoute: typeof AppImportJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/iscritti/': {
      id: '/_app/iscritti/'
      path: '/iscritti'
      fullPath: '/iscritti/'
      preLoaderRoute: typeof AppIscrittiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/iscritti/$gymMemberId': {
      id: '/_app/iscritti/$gymMemberId'
      path: '/iscritti/$gymMemberId'
      fullPath: '/iscritti/$gymMemberId'
      preLoaderRoute: typeof AppIscrittiGymMemberIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/iscritti/import': {
      id: '/_app/iscritti/import'
      path: '/iscritti/import'
      fullPath: '/iscritti/import'
      preLoaderRoute: typeof AppIscrittiImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/listini/': {
      id: '/_app/listini/'
      path: '/listini'
      fullPath: '/listini/'
      preLoaderRoute: typeof AppListiniIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/magazzino/': {
      id: '/_app/magazzino/'
      path: '/magazzino'
      fullPath: '/magazzino/'
      preLoaderRoute: typeof AppMagazzinoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operatori/': {
      id: '/_app/operatori/'
      path: '/operatori'
      fullPath: '/operatori/'
      preLoaderRoute: typeof AppOperatoriIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ordini/': {
      id: '/_app/ordini/'
      path: '/ordini'
      fullPath: '/ordini/'
      preLoaderRoute: typeof AppOrdiniIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizzazione/': {
      id: '/_app/organizzazione/'
      path: '/organizzazione'
      fullPath: '/organizzazione/'
      preLoaderRoute: typeof AppOrganizzazioneIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/palinsesto/': {
      id: '/_app/palinsesto/'
      path: '/palinsesto'
      fullPath: '/palinsesto/'
      preLoaderRoute: typeof AppPalinsestoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/piani-alimentari/': {
      id: '/_app/piani-alimentari/'
      path: '/piani-alimentari'
      fullPath: '/piani-alimentari/'
      preLoaderRoute: typeof AppPianiAlimentariIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reception/': {
      id: '/_app/reception/'
      path: '/reception'
      fullPath: '/reception/'
      preLoaderRoute: typeof AppReceptionIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/registro/': {
      id: '/_app/registro/'
      path: '/registro'
      fullPath: '/registro/'
      preLoaderRoute: typeof AppRegistroIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scadenzario/': {
      id: '/_app/scadenzario/'
      path: '/scadenzario'
      fullPath: '/scadenzario/'
      preLoaderRoute: typeof AppScadenzarioIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schede/': {
      id: '/_app/schede/'
      path: '/schede'
      fullPath: '/schede/'
      preLoaderRoute: typeof AppSchedeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/segmenti/': {
      id: '/_app/segmenti/'
      path: '/segmenti'
      fullPath: '/segmenti/'
      preLoaderRoute: typeof AppSegmentiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/servizi/': {
      id: '/_app/servizi/'
      path: '/servizi'
      fullPath: '/servizi/'
      preLoaderRoute: typeof AppServiziIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/utenti/': {
      id: '/_app/utenti/'
      path: '/utenti'
      fullPath: '/utenti/'
      preLoaderRoute: typeof AppUtentiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/utenti/$userId': {
      id: '/_app/utenti/$userId'
      path: '/utenti/$userId'
      fullPath: '/utenti/$userId'
      preLoaderRoute: typeof AppUtentiUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vendite/': {
      id: '/_app/vendite/'
      path: '/vendite'
      fullPath: '/vendite/'
      preLoaderRoute: typeof AppVenditeIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppImpostazioniRoute: typeof AppImpostazioniRoute
  AppIndexRoute: typeof AppIndexRoute
  AppContattiImportRoute: typeof AppContattiImportRoute
  AppEserciziBulkRoute: typeof AppEserciziBulkRoute
  AppImportJobIdRoute: typeof AppImportJobIdRoute
  AppIscrittiGymMemberIdRoute: typeof AppIscrittiGymMemberIdRoute
  AppIscrittiImportRoute: typeof AppIscrittiImportRoute
  AppUtentiUserIdRoute: typeof AppUtentiUserIdRoute
  AppAffollamentoIndexRoute: typeof AppAffollamentoIndexRoute
  AppAgendaIndexRoute: typeof AppAgendaIndexRoute
  AppAnalisiIndexRoute: typeof AppAnalisiIndexRoute
  AppAutomazioniIndexRoute: typeof AppAutomazioniIndexRoute
  AppContattiIndexRoute: typeof AppContattiIndexRoute
  AppDocumentiIndexRoute: typeof AppDocumentiIndexRoute
  AppEserciziIndexRoute: typeof AppEserciziIndexRoute
  AppImportIndexRoute: typeof AppImportIndexRoute
  AppIscrittiIndexRoute: typeof AppIscrittiIndexRoute
  AppListiniIndexRoute: typeof AppListiniIndexRoute
  AppMagazzinoIndexRoute: typeof AppMagazzinoIndexRoute
  AppOperatoriIndexRoute: typeof AppOperatoriIndexRoute
  AppOrdiniIndexRoute: typeof AppOrdiniIndexRoute
  AppOrganizzazioneIndexRoute: typeof AppOrganizzazioneIndexRoute
  AppPalinsestoIndexRoute: typeof AppPalinsestoIndexRoute
  AppPianiAlimentariIndexRoute: typeof AppPianiAlimentariIndexRoute
  AppReceptionIndexRoute: typeof AppReceptionIndexRoute
  AppRegistroIndexRoute: typeof AppRegistroIndexRoute
  AppScadenzarioIndexRoute: typeof AppScadenzarioIndexRoute
  AppSchedeIndexRoute: typeof AppSchedeIndexRoute
  AppSegmentiIndexRoute: typeof AppSegmentiIndexRoute
  AppServiziIndexRoute: typeof AppServiziIndexRoute
  AppUtentiIndexRoute: typeof AppUtentiIndexRoute
  AppVenditeIndexRoute: typeof AppVenditeIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppImpostazioniRoute: AppImpostazioniRoute,
  AppIndexRoute: AppIndexRoute,
  AppContattiImportRoute: AppContattiImportRoute,
  AppEserciziBulkRoute: AppEserciziBulkRoute,
  AppImportJobIdRoute: AppImportJobIdRoute,
  AppIscrittiGymMemberIdRoute: AppIscrittiGymMemberIdRoute,
  AppIscrittiImportRoute: AppIscrittiImportRoute,
  AppUtentiUserIdRoute: AppUtentiUserIdRoute,
  AppAffollamentoIndexRoute: AppAffollamentoIndexRoute,
  AppAgendaIndexRoute: AppAgendaIndexRoute,
  AppAnalisiIndexRoute: AppAnalisiIndexRoute,
  AppAutomazioniIndexRoute: AppAutomazioniIndexRoute,
  AppContattiIndexRoute: AppContattiIndexRoute,
  AppDocumentiIndexRoute: AppDocumentiIndexRoute,
  AppEserciziIndexRoute: AppEserciziIndexRoute,
  AppImportIndexRoute: AppImportIndexRoute,
  AppIscrittiIndexRoute: AppIscrittiIndexRoute,
  AppListiniIndexRoute: AppListiniIndexRoute,
  AppMagazzinoIndexRoute: AppMagazzinoIndexRoute,
  AppOperatoriIndexRoute: AppOperatoriIndexRoute,
  AppOrdiniIndexRoute: AppOrdiniIndexRoute,
  AppOrganizzazioneIndexRoute: AppOrganizzazioneIndexRoute,
  AppPalinsestoIndexRoute: AppPalinsestoIndexRoute,
  AppPianiAlimentariIndexRoute: AppPianiAlimentariIndexRoute,
  AppReceptionIndexRoute: AppReceptionIndexRoute,
  AppRegistroIndexRoute: AppRegistroIndexRoute,
  AppScadenzarioIndexRoute: AppScadenzarioIndexRoute,
  AppSchedeIndexRoute: AppSchedeIndexRoute,
  AppSegmentiIndexRoute: AppSegmentiIndexRoute,
  AppServiziIndexRoute: AppServiziIndexRoute,
  AppUtentiIndexRoute: AppUtentiIndexRoute,
  AppVenditeIndexRoute: AppVenditeIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  InvitoRoute: InvitoRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
